import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconVisionProApp: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="vision-pro-app, window"><path d="M0.75 8.75V13.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M19.25 17.1786H22.25V4.75H3.75V17.1786H6.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M6.75 19.25V16.25H19.25V19.25H6.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconVisionProApp;
